import { gsap } from 'gsap';

export default function initAnimation(
    root: HTMLElement,
    container: HTMLElement,
) {
    const items = gsap.utils.toArray<HTMLElement>('.advantage-item', container);

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: container, // 使用 grid 容器作为触发器
            start: 'top bottom-=10%', // 当 grid 容器顶部到达视口中心时开始
            end: 'top bottom-=10%', // 当 grid 容器底部到达视口中心时结束
            // toggleActions: 'restart', // 控制动画的开始和结束行为
            // markers: true, // 显示标记以便调试
        },
    });

    items.forEach((item, index) => {
        tl.from(item, {
            opacity: 0, // 从透明开始
            y: 25, // 从下方 50px 的位置开始动画
            duration: 0.6,
            delay: -0.4, // 每个 item 之间的延迟
            ease: 'sine.inOut',
        });
    });
}
